import type { GetImage } from '../../../app-core/lib/image/GetImage'

export const Imag_getSharedImage: GetImage = (image) => `shared/images/${image}.svg`
